import { useAppSelector } from 'flow/hooks/useRedux';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import BaseModal, { modalSizes } from 'flow/components/ui-components/BaseModal';
import Button from 'flow/components/ui-components/Button';
import MeetingJoinInfo from 'flow/components/meeting/shared/MeetingJoinInfo';
import {
    selectLobbyChatSessionKey,
    selectLobbyNumber,
    selectLobbyPin,
} from 'flow/selectors/meeting-selectors';

interface Props {
    name?: string;
    meetingCode?: string;
}

const InstantMeetingModal = ({ name = '', meetingCode = '' }: Props) => {
    const { i18next } = useAppContext();
    const { closeModal } = useModal();

    const number = useAppSelector(selectLobbyNumber);
    const pin = useAppSelector(selectLobbyPin);
    const chatSessionKey = useAppSelector(selectLobbyChatSessionKey);

    return (
        <BaseModal
            open={true}
            header={name || i18next.t('meetings.instant_meeting.title')}
            modalSize={modalSizes.MEDIUM}
            disableActions={true}
        >
            <div className="flex flex-col gap-y-4 pb-2">
                <MeetingJoinInfo
                    meetingCode={meetingCode}
                    number={number}
                    pinCode={pin}
                    showDialButton={false}
                    shouldShowVideo={true}
                    chatSessionKey={chatSessionKey}
                />

                <div className="flex justify-end border-t pt-4">
                    <Button color="secondary" onClick={closeModal}>
                        {i18next.t('modal.close')}
                    </Button>
                </div>
            </div>
        </BaseModal>
    );
};

export default InstantMeetingModal;
